/**
 * a 404 NOT FOUND page
 * 
 */
export const NotFound: React.FC = () => {
    return (
        <div className="room">
            <div className="room-head" style={{ color: "#284651", textAlign: "center" }}>
                Sieht mir nicht nach einem Schreibraum aus...
            </div>
            <div className="room-image-container">
                <div className="layer img bg-image-blur" style={{ backgroundImage: "url(/img/404.jpg)" }} />
            </div>
            <div className="room-info" style={{ color: "#284651", textAlign: "center" }}>
                Was könnte hier sein?
            </div>
        </div>
    );
};

export default NotFound;